<!--<button class="fancy-button" [disabled]="disabled" (click)="buttonClicked()">
  <span><ng-content></ng-content></span>
</button>-->

<button class="button" >
  <span class="actual-text" #actualContent><ng-content></ng-content></span>
  <span class="hover-text" aria-hidden="true" [innerHTML]="content"></span>
</button>
